module.exports = __webpack_public_path__ + "img/toastmasters.fd546875.png";